<h3>Invitation link</h3>
<input
  *ngIf="!(isLoadingInvitationLink$ | async); else loading"
  disabled
  value="{{ invitationLink$ | async }}"
/>
<ng-template #loading>
  <app-loading-spinner></app-loading-spinner>
</ng-template>
<div class="footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close()"
  >
    Close
  </button>
  <button
    type="button"
    class="btn btn-success"
    [ngClass]="{ disabled: isLoadingInvitationLink$ | async }"
    ngxClipboard
    [cbContent]="invitationLink$ | async"
  >
    Copy to clipboard
  </button>
</div>
